angular
    .module('MW.Framework.CoreStaticPageController', [])
    .controller('CoreStaticPageController', [
        '$scope',
        function($scope) {
            'use strict';

            $scope.isPageChromeless = false;
            $scope.useMaterial = false;
            $scope.useActionBar = false;
            $scope.staticPageData = {
                isStaticPage: false,
                staticPage: null
            };
            $scope.isSubTabsBarVisible = false;
            $scope.subTabsConfig = {
                activeTab: ''
            };

            $scope.$on('$routeChangeStart', function onRouteChangeStart($event, newRoute) {

                /*Toggle between flex padding and generic app margin if route uses Material*/
                if (newRoute.$$route && newRoute.$$route.useMaterial) {
                    $scope.useMaterial = true;
                } else {
                    $scope.useMaterial = false;
                }

                /*Need to process this before route change success if new route is chromeless*/
                if(newRoute.$$route && newRoute.$$route.isChromeless) {
                    $scope.isPageChromeless = (newRoute && newRoute.$$route && newRoute.$$route.isChromeless) ? true : false;
                    $scope.subTabsConfig.activeTab = newRoute.$$route.activeTab;
                    $scope.subTabsConfig.hideSubTabs = newRoute.$$route.hideSubTabs || false;
                }
            });

            $scope.$on('$routeChangeSuccess', function onRouteChangeStart($event, newRoute) {
                $scope.isPageChromeless = (newRoute && newRoute.$$route && newRoute.$$route.isChromeless) ? true : false;

                if (typeof newRoute.$$route !== 'undefined' && newRoute.$$route.isStaticPage) {
                    $scope.staticPageData.isStaticPage = true;
                    $scope.staticPageData.staticPage = newRoute.$$route.staticPage;
                } else {
                    $scope.staticPageData.isStaticPage = false;
                    $scope.staticPageData.staticPage = null;

                    if(newRoute.$$route && !newRoute.$$route.isChromeless) {
                        $scope.subTabsConfig.activeTab = newRoute.$$route.activeTab;
                        $scope.subTabsConfig.hideSubTabs = newRoute.$$route.hideSubTabs || false;
                    }
                }
            });

            $scope.$watch('subTabsConfig', function scopeWatchAlerts(newValue) {
                $scope.$broadcast('subTabsConfig', newValue);
            }, true);

            $scope.$on('isIcmCountriesEntitlement', function isIcmCountriesEntitlement() {
                $scope.$broadcast('subTabsConfig', $scope.subTabsConfig);
            });
        }
    ]);